module.exports = __webpack_public_path__ + "assets/images/announcement-CO2-emulator.jpg";